// extracted by mini-css-extract-plugin
export default {"generalError":"vsyFfS","modal":"wx6uwR","generalErrorContent":"bLqb_D","circleIcon":"lzvfo4","generalErrorText":"_8q7u5F"};